import React from 'react';
import Modal from '../Modal';
import '../FirmList/FirmList.scss';
import './AgentDuplicateModal.scss';

export function agentName(agent) {
    return (agent.NAME || [agent.FIRST_NAME, agent.LAST_NAME].filter(Boolean).join(' ') || '').trim();
}

/**
 * The Add Firm popup's "already exists" step, for agents. Each namesake opens
 * in a new tab, so the form stays as typed.
 */
export default function AgentDuplicateModal({ show, message, agents = [], busy = false, error = null, onBack, onAddAnyway }) {
    return (
        <Modal show={show} onClose={onBack} className="FirmList_modal AgentDuplicateModal">
            <div className="modal-content">
                <h2 className="FirmList_modal_title">Agent already exists</h2>
                <div className="FirmList_modal_confirm">
                    <p>{message || 'This agent is already in iCLIMB.'}</p>
                    <ul className="AgentDuplicateModal_list">
                        {agents.map((agent) => (
                            <li key={agent.ARCIMEDES_ROW_ID} className="AgentDuplicateModal_item">
                                <a href={`${arc.path.base}agent/${agent.ARCIMEDES_ROW_ID}`} target="_blank" rel="noopener noreferrer">
                                    {agentName(agent)}
                                </a>
                                <span className="AgentDuplicateModal_details">
                                    {[agent.FIRM_NAME, agent.EMAIL, agent.PHONE, agent.CELL_PHONE].filter(Boolean).join(' · ')}
                                </span>
                            </li>
                        ))}
                    </ul>
                    <p>Do you want to add this one anyway?</p>
                    {error && (
                        <div className="Alert Alert--error" style={{ marginBottom: 12 }}>
                            {error}
                        </div>
                    )}
                    <div className="FirmList_modal_form_footer">
                        <button type="button" className="button-new negative" onClick={onBack}>
                            Back
                        </button>
                        <button type="button" className="button-new positive" onClick={onAddAnyway} disabled={busy}>
                            {busy ? 'Saving…' : 'Add Anyway'}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
